export default function ComingSoon({ title }) {
  return (
    <div className="p-8 text-center">
      <h1 className="text-2xl">{title}</h1>
      <p className="mt-4 text-gray-600">This deep dive is coming soon—stay tuned!</p>
    </div>
  );
}
